export default __webpack_public_path__ + "static/media/share_catalogue.82bf85fa.svg";